<template>
  <div class="schoolUserInfo">
    <a-tabs v-model:activeKey="activeKey" @change="changeTab">
      <a-tab-pane key="1" tab="基本信息">
        <div class="container" v-if="!isShowLoading">
          <div class="topBtn">
            <a-button type="link" class="rightTxt" @click="handleRefresh"
              >刷新</a-button
            >
            <a-popconfirm
              title="确定解绑?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="unBindM"
              placement="leftTop">
              <a-button type="link" class="rightTxt">解绑</a-button>
            </a-popconfirm>
          </div>
          <!-- 新样式添加圆角盒子 -->
          <div
            class="radiusBox"
            :style="{ paddingBottom: isshow > 0 ? '25px' : '10px' }">
            <!-- 基本信息 -->
            <div class="formBox">
              <div class="formRow">
                <label>客户经理</label>
                <div>
                  <a-tag
                    style="
                      color: #1890ff;
                      background-color: #eaf5ff;
                      border: none;
                    "
                    v-if="customerDetails.basicCustomerInfo?.customerUserName"
                    >{{ customerDetails.basicCustomerInfo.customerUserName }}
                  </a-tag>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="formRow">
                <label>班主任企微</label>
                <div
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  ref="wechatRef">
                  <!-- v-if="filtername(customerDetails.basicCustomerInfo.addClassTeacherEnterpriseName).length > 0" -->
                  <template
                    v-if="
                      customerDetails.basicCustomerInfo
                        ?.addClassTeacherEnterpriseName.length > 0
                    ">
                    <!-- 超出显示 -->
                    <a-tooltip
                      placement="top"
                      v-if="isOverflowFlag"
                      :overlayStyle="{ width: '200px', margin: '0 auto' }">
                      <template #title>
                        <a-tag
                          color="#18bc9c"
                          v-for="(item, index) in customerDetails
                            .basicCustomerInfo.addClassTeacherEnterpriseName"
                          :key="index"
                          style="
                            margin: 5px;
                            color: #ffffff;
                            background-color: #18bc9c;
                          "
                          >{{ item }}</a-tag
                        >
                      </template>
                      <a-tag
                        color="#18bc9c"
                        v-for="(item, index) in customerDetails
                          .basicCustomerInfo.addClassTeacherEnterpriseName"
                        :key="index"
                        style="color: #ffffff; background-color: #18bc9c"
                        >{{ item }}</a-tag
                      >
                    </a-tooltip>
                    <!-- 不超出 -->
                    <!-- v-else -->
                    <a-tag
                      v-else
                      color="#18bc9c"
                      v-for="(item, index) in customerDetails.basicCustomerInfo
                        .addClassTeacherEnterpriseName"
                      :key="index"
                      style="color: #ffffff; background-color: #18bc9c"
                      >{{ item }}</a-tag
                    >
                  </template>
                  <span v-else>-</span>
                </div>
                <!-- <span>{{
              filtername(customerDetails.basicCustomerInfo.crmAddWechatName) || "-"
            }}</span> -->
              </div>
              <!-- <div class="formRow" v-if="getUserInfoDetails.length > 0"> -->
              <DynamicForm
                class="crmForm"
                ref="crmForm"
                :form="customerDetails.crmPersonalCustomerModel"
                :fieldList="getUserInfoDetails"
                :filterType="0"
                :isEdit="false"
                :isEditFrozen="true"
                :isFieldCascadeRule="isFieldCascadeRule"
                :cascadeFieldConfigList="cascadeFieldConfigList"
                formType="crm" />
              <!-- </div> -->
            </div>
            <div class="moreBtn" @click="showOrderDetail()" v-if="isshow">
              查看更多
            </div>
          </div>
          <!-- <a-divider /> -->

          <!-- 新样式添加圆角盒子 -->
          <div class="radiusBox paddbox">
            <div class="newTitleBox">
              <div class="infoTitle">学员信息</div>
              <div class="operate">
                <a-button
                  type="link"
                  class="rightTxt"
                  @click="editM()"
                  v-if="!isEdit"
                  >编辑</a-button
                >
                <a-button
                  type="primary"
                  @click="saveM()"
                  size="small"
                  v-if="isEdit"
                  >保存</a-button
                >
                <a-button
                  type="link"
                  class="rightTxt"
                  @click="cancelM()"
                  v-if="isEdit"
                  >取消</a-button
                >
              </div>
            </div>
            <div class="smallTitle">
              <label style="font-size: 15px">crm学员信息</label>
            </div>
            <div class="formBox">
              <!-- 同步crm并且有配字段才显示 -->
              <DynamicForm
                class="crmForm"
                ref="crmForm"
                :form="crmForm"
                :crmCustomerModel="customerDetails.crmCustomerModel"
                :fieldList="customerDetails.crmInfoFields"
                :filterType="0"
                :isEdit="isEdit"
                :isEditFrozen="true"
                :isFieldCascadeRule="isFieldCascadeRule"
                :cascadeFieldConfigList="cascadeFieldConfigList"
                formType="crm"
                v-if="
                  customerDetails.basicCustomerInfo.isExistCrmCustomer == 1 &&
                  customerDetails.crmInfoFields &&
                  customerDetails.crmInfoFields.length > 0
                " />
              <!-- 已同步但是没有配字段 -->
              <div
                class="nullBox"
                v-else-if="
                  customerDetails.crmInfoFields.length == 0 &&
                  customerDetails.basicCustomerInfo.isExistCrmCustomer == 1
                ">
                <div class="txt">暂无学员信息。</div>
              </div>
              <!-- 没有同步或者没有绑定就展示这个 -->
              <div class="nullBox" v-else>
                <div class="txt">学员未同步至网校,暂无信息。</div>
              </div>
            </div>
            <!-- </template> -->
            <a-divider />
            <!-- 网校学员信息 -->
            <div class="smallTitle">
              <label style="font-size: 15px">网校学员信息</label>
            </div>
            <!-- school自自定义表单 -->
            <div class="formBox">
              <DynamicForm
                class="schoolForm"
                ref="schoolForm"
                :form="schoolForm"
                :fieldList="customerDetails.schoolInfoFields"
                :filterType="0"
                :isEdit="isEdit"
                :isEditFrozen="true"
                formType="school"
                v-if="
                  customerDetails.schoolInfoFields &&
                  customerDetails.schoolInfoFields.length > 0
                "
                @update:value="updateValue" />
              <div class="nullBox" v-else>
                <div class="txt">暂无网校学员信息</div>
              </div>
            </div>
            <!-- </template> -->
          </div>
        </div>
        <div class="loadingMask" v-else>
          <a-spin tip="请稍等……" />
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="订单信息">
        <orderInfo
          ref="orderInfo"
          :externalUserId="externalUserId"
          :customerDetails="customerDetails"
          :userInfo="userInfo" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {
  displayCustomerDetails,
  queryOnlineSchoolCustomerOrder,
  editCustomerWeComBarDetails,
  selectPayWayDetailsByOrderId,
} from "@/api/detail";
import { getCurExternalContact } from "@/utils/wxCodeAuth";
import { checkMixin } from "@/mixins/checkMixin";
import { envjudge, getRSAData } from "@/utils/index";
import { moneyFormat } from "@/filters";
import customForm from "@/views/components/customForm";
import { DynamicForm } from "@/components/DynamicComponents";
import store from "@/store";
import { initDictOptions } from "@/utils/DictUtil";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import Vue from "vue";
import orderInfo from "@/views/components/orderInfo";

export default {
  name: "schoolUserInfo",
  filters: { moneyFormat },
  components: {
    customForm,
    DynamicForm,
    orderInfo,
  },
  data() {
    return {
      activeKey: "1",
      isShowLoading: false,
      customerDetails: {},
      externalUserId: "",
      userInfo: "",
      onlineSchoolCustomerOrder: "",
      // 表格头-必写
      columns: [
        {
          title: "orderCourseCreateTime",
          dataIndex: "orderCourseCreateTime",
          ellipsis: false,
          align: "center",
        },
        {
          title: "majorName",
          dataIndex: "majorName",
          ellipsis: true,
          align: "center",
        },
        {
          title: "classTypeName",
          dataIndex: "classTypeName",
          ellipsis: true,
          align: "center",
        },
      ],
      userInfo: {},
      crmForm: {},
      schoolForm: {},
      isshow: true,
      isEdit: false,
      isShowOrderDetail: false,
      isShowNoOrderDetail: false,
      orderDetailList: "",
      payStatusColors: {
        1: "#F59A24",
        2: "#6DC83E",
        3: "#D9021C",
        4: "#D9021C",
      },
      payStatusOptions: {
        1: "待支付",
        2: "已支付",
        3: "缴费中",
        4: "已失效",
      },
      // 是否有字段关联规则11
      isFieldCascadeRule: false,
      // 字段关联规则集合22
      cascadeFieldConfigList: [],
      isOverflowFlag: false,
      activeKey: "1",
    };
  },
  mixins: [checkMixin],

  computed: {
    getUserInfoDetails() {
      if (
        this.customerDetails.crmPersonalInfoFields &&
        this.customerDetails.crmPersonalInfoFields.length
      ) {
        this.isshow = true;
        return this.customerDetails.crmPersonalInfoFields.slice(0, 4);
      }

      return [];
    },
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const dom = this.$refs.wechatRef;
        if (dom) {
          this.isOverflowFlag = dom.scrollWidth > dom.clientWidth;
        }
        console.log("🚀 ~ this.$nextTick ~ dom:", dom);
      });
    },
    getRSAData,
    //刷新
    async handleRefresh() {
      this.isShowLoading = true;
      await this.checkIsBindM();
      await this.displayCustomerDetailsM();
      this.isShowLoading = false;
    },
    updateValue(e) {},
    // 更改编辑，用于回填判断
    changeEdit(isEdit) {
      const form = {};
      // crm回填判断 isExistCrmCustomer是否同步至crm 1是同步 0是未同步
      if (
        this.customerDetails.basicCustomerInfo &&
        this.customerDetails.basicCustomerInfo.isExistCrmCustomer === 1
      ) {
        this.customerDetails.crmInfoFields.forEach((item) => {
          // console.log(isEdit,item.fieldName, " 是否回填", Number(item.isAutoBackfill));
          if (isEdit) {
            form[item.fieldCode] = Number(item.isAutoBackfill)
              ? this.getFieldValue(
                  item.fieldCode,
                  item.fieldFormType,
                  this.customerDetails.crmCustomerModel
                )
              : "";
          } else {
            // 复制记录
            form[item.fieldCode] = this.getFieldValue(
              item.fieldCode,
              item.fieldFormType,
              this.customerDetails.crmCustomerModel
            );
          }
          let fieldVal = this.customerDetails.crmCustomerModel;
          Object.keys(fieldVal).forEach((key) => {
            if (`encrypt${item.fieldCode}` === key) {
              form[key] = fieldVal[key] || "";
            }
            if (`presetEncrypt${item.fieldCode}` === key) {
              form[key] = fieldVal[key] || ''
            }
          });
        });
        this.crmForm = JSON.parse(JSON.stringify(form));
      }
      // school回填判断
      //   if (this.customerDetails.basicCustomerInfo.schoolCustomerNo) {
      const schoolForm = {};
      this.customerDetails.schoolInfoFields.forEach((item) => {
        if (isEdit) {
          schoolForm[item.fieldCode] = Number(item.isAutoBackFill)
            ? this.getFieldValue(
                item.fieldCode,
                item.fieldFormType,
                this.customerDetails.schoolCustomerModel
              )
            : "";
        } else {
          // 复制记录
          item["copyObject"] = {
            corpId: store.getters.corpId,
            wechatUserId: this.userInfo.userId,
            externalCustomerId: this.externalUserId,
            fieldCode: item.fieldCode,
            content: "",
            copyFieldValue: "",
            customerId: this.customerDetails.schoolCustomerModel.id,
            // moduleType: "20",
            // operateDataId: this.customerDetails.crmCustomerModel.id,
            pageName: "企微侧边栏-客户详情",
            tablecodeList: [0],
            sysPermissionId: "",
            dataCopyPlatform: 1, // 0: PC、1: APP
            tenantId: store.getters.tenantId,
          };

          schoolForm[item.fieldCode] = this.getFieldValue(
            item.fieldCode,
            item.fieldFormType,
            this.customerDetails.schoolCustomerModel
          );
          // console.log(940,schoolForm);
        }
        let fieldVal = this.customerDetails.schoolCustomerModel;
        Object.keys(fieldVal).forEach((key) => {
          if (`encrypt${item.fieldCode}` === key) {
            console.log(932, key, fieldVal[key]);
            schoolForm[key] = fieldVal[key] || "";
          }
        });
      });
      // console.log(949,schoolForm);
      this.schoolForm = JSON.parse(JSON.stringify(schoolForm));
      //   }

      console.log(
        "切换编辑模式，更改的表单信息：",
        this.crmForm,
        this.schoolForm
      );
    },
    // 表单右上角编辑、保存、取消
    editM() {
      if (!this.customerDetails.basicCustomerInfo.isBoundUser)
        return this.$message.warn("您的企微尚未绑定网校用户，不可修改学员信息");
      this.changeEdit(true);
      this.isEdit = true;
    },
    // 显示订单明细弹窗
    async showOrderDetail(item = 0) {
      if (item) {
        if (!this.payStatusOptions) await this.getDictOptions();
        let { result } = await selectPayWayDetailsByOrderId({
          orderId: item.orderId,
          tenantId: store.getters.tenantId,
        });
        this.orderDetailList = result;
      }

      console.log("传之前获取参数", this.customerDetails, this.orderDetailList);

      // 跳转到 '/new-path' 并附带查询参数
      sessionStorage.setItem(
        "customerDetails",
        JSON.stringify(this.customerDetails)
      );
      let params = {
        path: "/detail",
        query: {
          order: this.orderDetailList,
          userId: this.userInfo.userId,
          externalCustomerId: this.externalUserId,
          corpId: store.getters.corpId,
        },
      };
      params.query.type = item ? "order" : "userInfo";

      this.$router.push(params);
    },
    async saveM() {
      this.handledecryptFormFields(this.crmForm);
      this.handledecryptFormFields(this.schoolForm);
      console.log("crmForm:", this.crmForm, "schoolForm:", this.schoolForm);
      let isPass = true;
      const postObj = {
        corpId: store.getters.corpId,
        wechatUserId: this.userInfo.userId,
        externalCustomerId: this.externalUserId,
        tenantId: store.getters.tenantId,
      };
      // crm相关校验-入参
      if (
        this.customerDetails.crmInfoFields &&
        this.customerDetails.crmInfoFields.length > 0
      ) {
        const resolve1 = await this.validateCrm();
        if (!resolve1) isPass = false;
        else {
          // crm相关保存
          postObj.entity = JSON.parse(JSON.stringify(this.crmForm));
          let crmChangeFields = [];
          crmChangeFields= this.$refs.crmForm.getpresetEncryptField();
          postObj.entity.changeFields = crmChangeFields
          console.log("🔍 ~ saveM ~ src/views/schoolUserInfo.vue:501 ~ crmChangeFields:", crmChangeFields);

          postObj.crmField = JSON.parse(
            JSON.stringify(this.customerDetails.crmInfoFields)
          );
        }
      }
      // school相关校验-入参
      if (
        this.customerDetails.basicCustomerInfo.CustomerNo &&
        this.customerDetails.schoolInfoFields &&
        this.customerDetails.schoolInfoFields.length > 0
      ) {
        const resolve2 = await this.validateSchool();
        if (!resolve2) isPass = false;
        else {
          // schoolField
          let schoolFieldAll = JSON.parse(
            JSON.stringify(this.customerDetails.schoolInfoFields)
          );
          //   console.log(1057,schoolFieldAll);
          // 区分值
          let schoolField1 = schoolFieldAll.filter(
            (item) => "" + item.type === "1"
          );
          let schoolField0 = schoolFieldAll.filter(
            (item) => "" + item.type === "0"
          );
          // 更新值
          for (let key in this.schoolForm) {
            for (let item of schoolField1) {
              if (key === item.fieldCode)
                item.fieldValue = this.schoolForm[key];
            }
            for (let item of schoolField0) {
              if (key === item.fieldCode)
                item.fieldValue = this.schoolForm[key];
              // console.log(1074,key,item.fieldCode,item.fieldValue);
            }
          }
          // 插入值
          //   postObj.schoolField = schoolField1;
          postObj.field = schoolField1;

          // customerEntityMap、customerUserInFoEntityMap
          const customerEntityMap = {};
          customerEntityMap.id = this.customerDetails.schoolCustomerModel.id;
          let changeFields = [];
         changeFields= this.$refs.schoolForm.getpresetEncryptField();
          customerEntityMap.changeFields = changeFields
           
          const customerUserInFoEntityMap = {};
          for (let item of schoolField0) {
            // 0网校学员主信息表 1网校学员用户信息表
            if (item.tableCode === 0)
              customerEntityMap[item.fieldCode] = item.fieldValue;
            else if (item.tableCode === 1)
              customerUserInFoEntityMap[item.fieldCode] = item.fieldValue;
          }
          postObj.customerEntityMap = customerEntityMap;
          postObj.customerUserInFoEntityMap = customerUserInFoEntityMap;
          //   postObj.tenantId = process.env.VUE_APP_WEB_TENANT_ID;
        }
      }
      if (!isPass) return this.$message.warn("请检查填写项");
      // 提交保存
      this.postSave(postObj);
    },
    //处理加密字段赋值
    handledecryptFormFields(form) {
      // console.log(1099,form);
      Object.keys(form).forEach((key) => {
        if (key.includes("encrypt")) {
          console.log("加密字段", key);
          let fieldCode = key.replace("encrypt", ""); // 移除'encrypt'前缀以获取原字段名
          form[fieldCode] = getRSAData(form[key]) || ""; // 解密数据并赋值
          delete form[key];
        }
      });
    },
    validateCrm() {
      return new Promise((resolve, reject) => {
        this.$refs.crmForm.validate((flag) => {
          if (!flag) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },
    validateSchool() {
      return new Promise((resolve, reject) => {
        this.$refs.schoolForm.validate((flag) => {
          if (!flag) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },
    cancelM() {
      if (this.$refs.crmForm) this.$refs.crmForm.resetFields();
      if (this.$refs.schoolForm) this.$refs.schoolForm.resetFields();
      this.changeEdit(false);
      this.isEdit = false;
    },
    // 保存提交
    async postSave(postObj) {
      console.log("postSave", postObj);
      const { result } = await editCustomerWeComBarDetails(postObj);
      console.log("保存成功！", result);
      this.isEdit = false;
      // 重新渲染
      this.customerDetails = "";
      this.isShowLoading = true;
      this.$message.success("保存成功");
      this.$nextTick(async () => {
        // 查询详情
        await this.displayCustomerDetailsM();
        this.isShowLoading = false;
      });
    },
    // 总计
    dealAmountM(item) {
      // 总计=成交总额+总扣款金额
      let dealAmount =
        (Number(item.dealAmount) || 0) +
        (Number(item.totalDeductionAmount) || 0);
      return dealAmount;
    },
    // 已缴
    paidAmountM(item) {
      // 已缴=总计-欠款金额+多缴金额
      // let dealAmount =
      //   (Number(item.dealAmount) || 0) +
      //   (Number(item.totalDeductionAmount) || 0);
      // let paidAmount =
      //   (Number(dealAmount) || 0) - (Number(item.oweAmount) || 0) + (Number(item.morePayAmountTotal) || 0);
      // return paidAmount;

      return item.paidAmount;
    },
    displayCustomerDetailsM() {
      console.log("进来这里");

      return new Promise(async (resolve, reject) => {
        if (!this.$route.params.configId) {
          console.warn("没有表单id");
          return reject();
        }
        if (!this.externalUserId)
          this.externalUserId = await getCurExternalContact();

        let { result } = await displayCustomerDetails({
          configId: this.$route.params.configId,
          externalCustomerId: this.externalUserId,
          corpId: store.getters.corpId,
          wechatUserId: this.userInfo.userId,
          isEncryptHandle: 1,
          tenantId: store.getters.tenantId,
        });
        this.customerDetails = result;
        console.log("输出拿到的结果", result);

        // //字段级联规则
        // if (result.cascadeFieldConfigList) {
        //   this.cascadeFieldConfigList = result.cascadeFieldConfigList;
        //   this.isFieldCascadeRule = Boolean(
        //     result.cascadeFieldConfigList.length
        //   );
        // }
        // 数据组合
        // 初始化基本信息表单
        this.crmForm = {};
        this.schoolForm = {};
        this.changeEdit(false);
        resolve();
      });
    },
    // field值过滤
    getFieldValue(fieldCode, fieldFormType, model) {
      let value = model[fieldCode];
      // 新增根据不同组件类型的空值处理
      if (!value) {
        if (["select", "radio"].includes(fieldFormType)) value = null;
        else value = "";
      }
      // 返回
      console.log(
        "当前类型",
        fieldFormType,
        "当前key:",
        fieldCode,
        "当前value:",
        value
      );
      if (["select", "radio"].includes(fieldFormType)) {
        if (value) return Number(value);
        else return value;
      } else {
        return value;
      }
    },
    queryOnlineSchoolCustomerOrderM() {
      return new Promise(async (resolve, reject) => {
        let corpId = store.getters.corpId;
        const { result } = await queryOnlineSchoolCustomerOrder({
          corpId: corpId,
          externalUserId: this.externalUserId,
          tenantId: store.getters.tenantId,
        });
        this.onlineSchoolCustomerOrder = result;
        resolve();
      });
    },
    getUserInfo() {
      // 兼容获取缓存和vuex的userInfo信息
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo || "" + userInfo === "undefined") {
        this.userInfo = store.getters.userInfo;
      } else {
        this.userInfo = JSON.parse(userInfo);
      }
      console.log("获取userInfo", this.userInfo);
    },
    // 切割昵称
    // teacherName(value) {
    //   const regex = /([^\(]+)(?:\s*)\((.+?)\)/;
    //   const match = value.match(regex);
    //   if (match) {
    //     return [match[1], match[2]];
    //   }
    //   return [value];
    // },

    handleClick() {
      console.log("点击了按钮");
    },

    filtername(value) {
      console.log("🚀 ~ filtername ~ value:", value);
      if (value == null) return [];
      //   let arr = JSON.parse(value);
      console.log("🚀 ~ filtername ~ arr:", arr);
      let targetArr = [];
      arr.forEach((item, index) => {
        item.name.match(/\(([^)]+)\)/g).forEach((element) => {
          console.log("拿到每一个值", element);

          targetArr.push({
            type: item.describe == "客户经理企微" ? 1 : 2,
            value: element.slice(1, -1),
          });
        });
      });

      let uniqueArray = [...new Set(targetArr.map(JSON.stringify))];
      targetArr = uniqueArray.map((item) => JSON.parse(item));
      // 排序 type 1在后，2在前
      targetArr.sort((a, b) => {
        return b.type - a.type;
      });
      return targetArr;
    },

    changeTab(activeKey) {
      if (activeKey === "1") {
        this.handleRefresh();
      } else {
        this.$nextTick(() => {
          this.$refs.orderInfo.init();
        });
      }
      console.log("什么东西", activeKey);
    },
  },
  async created() {
    this.isShowLoading = true;
    // 兼容获取缓存和vuex的userInfo信息
    this.getUserInfo();
    // 企微环境下检测和交互
    if (envjudge() === "com-wx-mobile" || envjudge() === "com-wx-pc") {
      // 检测未登录或授权
      this.checkLogin();
      // 检查是否已绑定crm账号
      await this.checkIsBindM();
      // 查询详情
      await this.displayCustomerDetailsM();
      console.log("看看", this.customerDetails);
      // if (this.customerDetails.basicCustomerInfo.CustomerNo) {
      //   await this.queryOnlineSchoolCustomerOrderM();
      // }
      this.isShowLoading = false;
    } else {
      //用于开发测试
      await this.displayCustomerDetailsM();
      // if (this.customerDetails.basicCustomerInfo.CustomerNo) {
      //   await this.queryOnlineSchoolCustomerOrderM();
      // }
      this.isShowLoading = false;
    }
    this.$nextTick(() => {
      this.checkOverflow();
    });
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less" scope>
.ant-tabs-bar {
  margin: 0 !important;
}
.schoolUserInfo {
  height: 100%;
  overflow: hidden;
  padding: 0;
}
.container {
  width: 100%;
  height: 90vh;
  overflow-y: scroll;
  overflow-x: hidden;
  // box-sizing: border-box;
  // height: 200px; /* 或其他高度 */
  // background: linear-gradient(
  //   to bottom,
  //   #1890ff 200px,
  //   white 200px,
  //   white 100%
  // );
  background: linear-gradient(
    to bottom,
    #1a90fe 0%,
    #ffffff 250px,
    #fafcff 251px,
    #fafcff 100%
  );

  // 顶部按钮
  .topBtn {
    width: 94%;
    display: flex;
    justify-content: flex-end;
    margin: 0 3%;
    padding: 5px 0 2px 0;

    button {
      color: white;
    }
  }

  // 新增学员信息圆角样式
  .radiusBox {
    width: 96% !important;
    border-radius: 10px;
    margin: 0 2% 2% 2%;
    // padding: 2% 0;
    background-color: #ffffff;
    position: relative;

    .moreBtn {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 11px;
      width: 70px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      color: #ffffff;
      // border: #1890ff 1px solid;
      border-radius: 10px 0 10px 0;
      background-color: #1890ff;
      cursor: pointer;
    }
  }

  .newOrderBox {
    &:last-child {
      padding-bottom: 2%;
    }

    .historyOrderCourseList {
      padding: 0 20px 16px 20px;
    }
  }

  // 新增订单信息圆角样式
  .radiusBoxOrder {
    width: 96% !important;
    border-radius: 10px;
    margin: 0 2% 2% 2%;
    // padding: 2% 0;
    background-color: white;
  }

  .outsideTitle {
    height: 30px;
    font-size: 16px;
    font-weight: 700;
    // padding-left: 40px;
    line-height: 40px;

    .title {
      color: #333333;
      position: relative;
      padding-left: 25px;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      margin-top: 10px;

      &::before {
        content: "";
        position: absolute;
        left: 10px;
        top: 0;
        width: 4px;
        height: 100%;

        // background: #1890ff;
        background: linear-gradient(180deg, #1a90fe 0%, #74b2eb 100%);
      }
    }
  }

  .paddbox {
    padding-bottom: 20px;
  }

  .nullBox {
    color: #ccc;
    height: 150px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .txt {
      width: 190px;
      text-align: center;
    }
  }

  .totalBox {
    background: rgb(242, 242, 242);
    border: 1px solid rgb(215, 215, 215);
    padding: 4px 4px;
    box-sizing: border-box;
    margin-top: 4px;
    font-size: 12px;
  }

  .tableLog {
    margin-top: 10px;

    .ant-table-title,
    td {
      padding: 10px 4px;
    }
  }

  .teacherName {
    display: inline-block;
    // white-space: normal;
    float: left;
  }

  .teacherNike {
    color: #8080ff;
    display: inline-block;
    // white-space: normal;
    // padding-left: 1px;
    float: left;
  }
}

.dialogClass {
  top: calc(50% - 245px);
}

.dialogClass2 {
  top: calc(50% - 95px);
}

.text-copy {
  color: #1890ff !important;
  cursor: pointer !important;
}
</style>
<style lang="less">
// 调整行高
.ant-form-item {
  // height: 35px;

  .ant-form-item-label > label {
    color: #666666 !important;
  }

  .ant-form-item-control-wrapper {
    // height: 35px;
    // line-height: 35px;

    .ant-form-item-control {
      // height: 35px;
      line-height: 35px;
      color: #111111;
    }
  }
}

.newOrderBox {
  .ant-table.ant-table-bordered .ant-table-title {
    border: none;
  }

  .ant-table-small {
    border: none;
  }

  .ant-table-body {
    border-radius: 5px;
    border: 1px solid #e8e8e8;
  }

  .ant-table-tbody {
    border-radius: 5px;
  }

  .ant-table-small.ant-table-bordered .ant-table-content {
    border-right: none;
  }
}
</style>
